import classNames from "classnames";
import React, { useState, createRef } from "react";
import { useClasses } from "../..";
import Field from "./Shared/Field";
import Menu from "./Shared/Menu";
import { styles } from "./Shared/Input";
const style = (theme) => {
    const inputStyles = styles(theme);
    return {
        inputHolder: inputStyles.inputHolder,
        inlineHolder: {
            "@media print": {
                padding: "18px 0px 0px 0px",
            },
        },
        input: {
            ...inputStyles.input,
            paddingRight: "35px",
            cursor: "pointer",
        },
        helpBlock: {
            fontSize: "0.8rem",
            lineHeight: "0.8rem",
            color: "rgba(0, 0, 0, 0.75)",
        },
        hasError: inputStyles.hasError,
        indicatorHolder: {
            textAlign: "right",
            "@media print": {
                display: "none",
            },
        },
        indicator: {
            position: "absolute",
            cursor: "pointer",
            width: 0,
            height: 0,
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderTop: `8px solid #797979`,
            margin: "12px 0px 0px -25px",
            "@media print": {
                display: "none",
            },
        },
        indicatorOpen: {
            position: "absolute",
            cursor: "pointer",
            width: 0,
            height: 0,
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderBottom: `8px solid #797979`,
            margin: "12px 0px 0px -25px",
            "@media print": {
                display: "none",
            },
        },
    };
};
const Select = (props) => {
    var _a, _b, _c;
    const classes = useClasses(style);
    const { inline = false, value, error } = props;
    const hasValue = Boolean(value);
    const [isFocused] = useState(false);
    const [inputRef] = useState(createRef());
    const hasError = Boolean(error);
    return (React.createElement(Field, { label: props.label, readOnly: props.readOnly, open: props.open, inline: props.inline, hasValue: hasValue, info: props.info, error: props.error, isFocused: isFocused, autoComplete: props.autoComplete, override: props.override, onLabelClick: () => props.setOpen(!open) },
        React.createElement("div", { className: classNames([
                inline ? classes.inlineHolder : classes.inputHolder,
            ]) },
            React.createElement("div", { className: classes.indicatorHolder },
                React.createElement("span", { className: classNames([
                        props.open ? classes.indicatorOpen : classes.indicator,
                        props.open
                            ? (_a = props.override) === null || _a === void 0 ? void 0 : _a.indicatorOpen
                            : (_b = props.override) === null || _b === void 0 ? void 0 : _b.indicator,
                    ]), onClick: () => props.setOpen(!open) })),
            React.createElement("div", { className: classNames([
                    classes.input,
                    hasError && classes.inputError,
                    (_c = props.override) === null || _c === void 0 ? void 0 : _c.input,
                ]), ref: inputRef, onClick: () => {
                    props.setOpen(!open);
                    if (props.onClick)
                        props.onClick();
                } }, props.value),
            props.open && (React.createElement(Menu, { anchor: inputRef, onClose: () => {
                    props.setOpen(false);
                }, onFocus: props.onFocus, onBlur: props.onBlur, override: props.override }, props.children)))));
};
export default Select;
